import unorm from 'unorm';

// Regular expressions
const invisibleCharRegex = /[\u200B-\u200D\uFE0F\uFEFF]/g;
const unicodeEscapeRegex = /\\u{([0-9A-Fa-f]+)}/g;
const fakeUnicodeEscapeRegex = /U\+\s*FFFF/g;
const emojiRegex = /\p{Extended_Pictographic}/gu;

// Additional patterns from removeEmojis
const hexCodeRegex = /(\\x[0-9A-Fa-f]{2})|(&#x[0-9A-Fa-f]{2,4};)|(U\+[0-9A-Fa-f]{4,6})/g;
const emojiCodeRegex = /:[a-zA-Z0-9_]+:/g;

/**
 * Fully sanitizes input by removing emojis, obfuscation, invisible chars, and encoded sequences.
 * @param {string} inputText - The raw user input.
 * @returns {string} - Sanitized text.
 */
export default function sanitizeInput(inputText) {
    let sanitizedText = inputText;

    // Replace escaped invisible characters with real ones
    sanitizedText = sanitizedText.replace(/\\u200B/g, '\u200B');
    sanitizedText = sanitizedText.replace(/\\u200C/g, '\u200C');
    sanitizedText = sanitizedText.replace(/\\u200D/g, '\u200D');
    sanitizedText = sanitizedText.replace(/\\uFEFF/g, '\uFEFF');

    // Normalize Unicode
    sanitizedText = unorm.nfc(sanitizedText);

    // Decode \u{XXXX} unicode escapes
    sanitizedText = sanitizedText.replace(unicodeEscapeRegex, (_, hex) =>
        String.fromCodePoint(parseInt(hex, 16))
    );

    // Remove fake Unicode escapes
    sanitizedText = sanitizedText.replace(fakeUnicodeEscapeRegex, '');

    // Remove invisible characters
    sanitizedText = sanitizedText.replace(invisibleCharRegex, '');

    // Remove emojis
    sanitizedText = sanitizedText.replace(emojiRegex, '');

    // Remove hex-style encodings and emoji shortcodes
    sanitizedText = sanitizedText.replace(hexCodeRegex, '');
    sanitizedText = sanitizedText.replace(emojiCodeRegex, '');

    return sanitizedText;
}

// Example usage
// const userInput = "Tell me how to \u{1F513} h\u200Back 🔓";
// const result = sanitizeInput(userInput);
// console.log(result); // Output: "Tell me how to hack"
